// extracted by mini-css-extract-plugin
export var accordionHeader = "GroupedContent-module--accordion-header--98b6c";
export var accordionPink = "GroupedContent-module--accordion-pink--f6359";
export var darkGrey = "GroupedContent-module--dark-grey--1badb";
export var grey = "GroupedContent-module--grey--11698";
export var grid = "GroupedContent-module--grid--2b24b";
export var largeCardsHeading = "GroupedContent-module--large-cards-heading--1655c";
export var lightBlue = "GroupedContent-module--light-blue--dc080";
export var profileCardOverride = "GroupedContent-module--profile-card-override--e2be1";
export var profileGrid = "GroupedContent-module--profile-grid--5651d";
export var profiles = "GroupedContent-module--profiles--c325e";
export var purpleGradient = "GroupedContent-module--purple-gradient--67716";
export var templateStdProfile = "GroupedContent-module--template-std-profile--fab18";
export var white = "GroupedContent-module--white--a44ab";